// Registro central de todos os namespaces de tradução. Importados estaticamente
// (bundled) para que o SSR/prerender da landing tenha as strings de forma
// síncrona — sem carregamento assíncrono no primeiro byte.

import ptCommon from "./locales/pt-BR/common.json";
import ptAuth from "./locales/pt-BR/auth.json";
import ptSettings from "./locales/pt-BR/settings.json";
import ptTasks from "./locales/pt-BR/tasks.json";
import ptDashboard from "./locales/pt-BR/dashboard.json";
import ptEditor from "./locales/pt-BR/editor.json";
import ptDrawings from "./locales/pt-BR/drawings.json";
import ptLanding from "./locales/pt-BR/landing.json";
import ptLegal from "./locales/pt-BR/legal.json";

import enCommon from "./locales/en/common.json";
import enAuth from "./locales/en/auth.json";
import enSettings from "./locales/en/settings.json";
import enTasks from "./locales/en/tasks.json";
import enDashboard from "./locales/en/dashboard.json";
import enEditor from "./locales/en/editor.json";
import enDrawings from "./locales/en/drawings.json";
import enLanding from "./locales/en/landing.json";
import enLegal from "./locales/en/legal.json";

export const resources = {
  "pt-BR": {
    common: ptCommon,
    auth: ptAuth,
    settings: ptSettings,
    tasks: ptTasks,
    dashboard: ptDashboard,
    editor: ptEditor,
    drawings: ptDrawings,
    landing: ptLanding,
    legal: ptLegal,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    settings: enSettings,
    tasks: enTasks,
    dashboard: enDashboard,
    editor: enEditor,
    drawings: enDrawings,
    landing: enLanding,
    legal: enLegal,
  },
} as const;

export const ns = ["common", "auth", "settings", "tasks", "dashboard", "editor", "drawings", "landing", "legal"] as const;
export const defaultNS = "common";
